export enum DecisionCriteria {
  Eave20180917Jumbo20Percent = "Eave20180917Jumbo20Percent",
  Eave20181001Jumbo10Percent = "Eave20181001Jumbo10Percent",
  Eave20181001Jumbo20Percent = "Eave20181001Jumbo20Percent",
  Eave20190119Conforming20Percent = "Eave20190119Conforming20Percent",
  Eave20190119Jumbo10Percent = "Eave20190119Jumbo10Percent",
  Eave20190119Jumbo20Percent = "Eave20190119Jumbo20Percent",
  Eave20190624Conforming20Percent = "Eave20190624Conforming20Percent",
  Eave20190624Jumbo10Percent = "Eave20190624Jumbo10Percent",
  Eave20190624Jumbo20Percent = "Eave20190624Jumbo20Percent",
  Eave20200325ConformingLowDownpayment = "Eave20200325ConformingLowDownpayment",
  Eave20190624Jumbo = "Eave20190624Jumbo",
  Eave20210924Conforming = "Eave20210924Conforming",
  Eave20220112VA = "Eave20220112VA",
}

export const DecisionCriteriaDisplayValues: { [key in DecisionCriteria]: string } = {
  [DecisionCriteria.Eave20180917Jumbo20Percent]: "Eave20180917Jumbo20Percent",
  [DecisionCriteria.Eave20181001Jumbo10Percent]: "Eave20181001Jumbo10Percent",
  [DecisionCriteria.Eave20181001Jumbo20Percent]: "Eave20181001Jumbo20Percent",
  [DecisionCriteria.Eave20190119Conforming20Percent]: "Eave20190119Conforming20Percent",
  [DecisionCriteria.Eave20190119Jumbo10Percent]: "Eave20190119Jumbo10Percent",
  [DecisionCriteria.Eave20190119Jumbo20Percent]: "Eave20190119Jumbo20Percent",
  [DecisionCriteria.Eave20190624Conforming20Percent]: "Conforming Mainstream",
  [DecisionCriteria.Eave20190624Jumbo10Percent]: "Jumbo Low Downpayment",
  [DecisionCriteria.Eave20190624Jumbo20Percent]: "Jumbo Mainstream",
  [DecisionCriteria.Eave20200325ConformingLowDownpayment]: "Conforming Low Downpayment",
  [DecisionCriteria.Eave20190624Jumbo]: "Jumbo",
  [DecisionCriteria.Eave20210924Conforming]: "Conforming",
  [DecisionCriteria.Eave20220112VA]: "VA",
};

export function activeDecisionCriteriaWithBackwardsSupport(
  selectedDC?: string,
): DecisionCriteria[] {
  const dcs = [...ActiveDecisionCriteria];

  if (!selectedDC) {
    return ActiveDecisionCriteria;
  }

  const dc = DecisionCriteria[selectedDC as keyof typeof DecisionCriteria];
  // add the selected DC as a valid option if it's not currently active
  if (dcs.indexOf(dc) === -1) {
    dcs.push(dc);
  }

  return dcs;
}

export const ActiveDecisionCriteria: DecisionCriteria[] = [
  DecisionCriteria.Eave20210924Conforming,
  DecisionCriteria.Eave20190624Jumbo,
  DecisionCriteria.Eave20220112VA,
];

/** OrderedDecisionCriteria is handy for powering dropdowns */
export const OrderedDecisionCriteria: DecisionCriteria[] = [
  ...ActiveDecisionCriteria,
  // retired
  DecisionCriteria.Eave20190624Jumbo10Percent,
  DecisionCriteria.Eave20190624Jumbo20Percent,
  DecisionCriteria.Eave20200325ConformingLowDownpayment,
  DecisionCriteria.Eave20190624Conforming20Percent,
  DecisionCriteria.Eave20180917Jumbo20Percent,
  DecisionCriteria.Eave20181001Jumbo10Percent,
  DecisionCriteria.Eave20181001Jumbo20Percent,
  DecisionCriteria.Eave20190119Conforming20Percent,
  DecisionCriteria.Eave20190119Jumbo10Percent,
  DecisionCriteria.Eave20190119Jumbo20Percent,
];
